import React, { useEffect } from 'react'
import DegreeCard from './DegreeCard'
import { Link } from 'react-router-dom'
import { useStudentOptionsStore, useUserStore, useAppStore } from "../../stores";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import withReactContent from "sweetalert2-react-content";

const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
const MySwal = withReactContent(Swal);
const StudentNew = () => {
  const addAll = useStudentOptionsStore((state) => state.addAll);
  const getDegrees = useStudentOptionsStore((state) => state.getDegrees);
  const getBranches = useStudentOptionsStore((state) => state.getBranches);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  const loading = useAppStore(state => state.loading);
  const degs = getDegrees();
  // return degs.map((o, index) => {
  //   return (<option key={index} selected={index === 0} value={o._id}>{o.name}</option>)
  // })
  useEffect(() => {
    showLoading();
    fetch("/api/file/options")
      .then((res) => {
        if (res.status !== 200) {
          res.json()
            .then(r => {
              console.log(r.message);
              toast.error(r.message, toastOptions);
            })
        }
        else {
          res.json().then(response => {
            console.log(response);
            addAll(response);
            hideLoading();
          })
        }
      })
  }, [])
  console.log("degs", degs);
  if (loading) {
    return <h5>Loading...</h5>
  }
  return (
    <>
      {degs.map((degree, index) => (
        <div className='col-12 p-3'>
          <h1>{degree.name}</h1>
          <div className='row p-1'>
            {getBranches(degree._id).map((branch) => (<DegreeCard {...branch} />))}
          </div>
          <hr></hr>
        </div>
      ))}
    </>
  )
}

export default StudentNew